import { fetchAuthSession } from 'aws-amplify/auth';

export type AuthSession = Awaited<ReturnType<typeof fetchAuthSession>>;

let cachedSession: AuthSession | null = null;
let sessionPromise: Promise<AuthSession> | null = null;

export const isAuthSessionValid = (session: AuthSession | null): boolean => {
  if (!session) return false;
  const idTokenExp = session.tokens?.idToken?.payload?.exp;
  const credentialExp = session.credentials?.expiration?.getTime();
  const now = Date.now();

  const tokenValid =
    typeof idTokenExp === 'number' ? idTokenExp * 1000 > now : false;
  const credentialsValid =
    typeof credentialExp === 'number' ? credentialExp > now : true;

  return tokenValid && credentialsValid;
};

export const getAuthSession = async (): Promise<AuthSession> => {
  if (isAuthSessionValid(cachedSession)) {
    return cachedSession as AuthSession;
  }
  if (!sessionPromise) {
    sessionPromise = fetchAuthSession()
      .then((session) => {
        cachedSession = session;
        sessionPromise = null;
        return session;
      })
      .catch((err) => {
        sessionPromise = null;
        throw err;
      });
  }
  return sessionPromise;
};

export const clearCachedAuthSession = () => {
  cachedSession = null;
};
